export default "__VITE_ASSET__75066da9__"